
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink, context } from 'dumi/theme';
    import Previewer from 'dumi-theme-mobile/es/builtins/Previewer.js';
import Alert from 'dumi-theme-default/es/builtins/Alert';
import API from 'dumi-theme-default/es/builtins/API';
import Badge from 'dumi-theme-default/es/builtins/Badge';
import Example from 'dumi-theme-default/es/builtins/Example';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode';
import Tree from 'dumi-theme-default/es/builtins/Tree';
import Table from 'dumi-theme-default/es/builtins/Table';

    // memo for page content, to avoid useless re-render since other context fields changed
    const PageContent = React.memo(({ demos: DUMI_ALL_DEMOS }) => {
      const DumiDemo1 = DUMI_ALL_DEMOS['popup-demo'].component

      return (
        <>
          
          <React.Fragment><div className="markdown"><h1 id="popup-弹出层"><AnchorLink to="#popup-弹出层" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Popup 弹出层</h1>
<p>弹出层容器，用于展示弹窗、信息提示等内容，支持多个弹出层叠加展示</p>
<h3 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h3>
</div><Previewer {...DUMI_ALL_DEMOS['popup-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h3 id="api"><AnchorLink to="#api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API</h3>















































































































































<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>className</td><td>自定义 class 名</td><td>string</td><td>-</td></tr><tr><td>style</td><td>自定义样式</td><td>CSSProperties</td><td>-</td></tr><tr><td>zIndex</td><td>z-index 值</td><td>number</td><td>-</td></tr><tr><td>visible</td><td>是否显示</td><td>boolean</td><td>-</td></tr><tr><td>position</td><td>弹出方向，可选值 top, bottom, left, right, center</td><td>string</td><td>center</td></tr><tr><td>duration</td><td>动画执行时间（单位：毫秒）</td><td>number</td><td>300</td></tr><tr><td>overlay</td><td>是否展示遮罩层</td><td>boolean</td><td>true</td></tr><tr><td>overlayType</td><td>遮罩层的类型，可选值 transparent, normal</td><td>string</td><td>normal</td></tr><tr><td>lockScroll</td><td>是否锁定背景滚动</td><td>boolean</td><td>true</td></tr><tr><td>safeAreaInsetBottom</td><td>是否开启底部安全区适配</td><td>boolean</td><td>false</td></tr><tr><td>closeOnClickOverlay</td><td>是否在点击遮罩层后关闭</td><td>boolean</td><td>true</td></tr><tr><td>closeable</td><td>是否显示关闭图标</td><td>boolean</td><td>true</td></tr><tr><td>closeIconPosition</td><td>关闭图标位置，可选值为 top-right,top-left,bottom-left,bottom-right</td><td>boolean</td><td>top-right</td></tr><tr><td>children</td><td>组件中的内容</td><td>ReactElement</td><td>-</td></tr><tr><td>onOpen</td><td>打开弹出层时触发</td><td>()=&gt;void</td><td>-</td></tr><tr><td>onClose</td><td>关闭弹出层时触发</td><td>()=&gt;void</td><td>-</td></tr><tr><td>onOpened</td><td>打开弹出层且动画结束后触发</td><td>()=&gt;void</td><td>-</td></tr><tr><td>onClosed</td><td>关闭弹出层且动画结束后触发</td><td>()=&gt;void</td><td>-</td></tr><tr><td>onClickOverlay</td><td>点击遮罩层时触发的回调函数</td><td><code>(e: MouseEvent) =&gt; void</code></td><td>-</td></tr><tr><td>onClick</td><td>点击弹出层时触发</td><td><code>(e: MouseEvent) =&gt; void</code></td><td>-</td></tr><tr><td>onClickCloseIcon</td><td>点击关闭图标时触发</td><td><code>(e: MouseEvent) =&gt; void</code></td><td>-</td></tr><tr><td>mountContainer</td><td>指定 Popup 挂载的 HTML 节点</td><td><code>HTMLElement/() =&gt; HTMLElement</code></td><td>-</td></tr></tbody></Table></div></React.Fragment>
        </>
      );
    })

    export default (props) => {
      const { demos } = React.useContext(context);

      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return <PageContent demos={demos} />;
  }